import React, { CSSProperties } from 'react';

/** Type of logo to display. */
export enum eLogo {
  /** Standard logo. */
  standard = 0,
  /** Monochrome logo. */
  mono = 1
}

export interface LogoProps {
  width?: number;
  height?: number;
  logo?: eLogo;
  style?: CSSProperties;
  className?: string;
}

const LOGO_SRC: { [logo in eLogo]: string } = {
  [eLogo.standard]: '/public/stryder-logo.svg',
  [eLogo.mono]: '/public/stryder-logo-mono.svg'
};

const Logo = (props: LogoProps) => {
  const { width, height, style, className } = props;
  return (
    <>
      <img
        src={LOGO_SRC[props.logo || eLogo.standard]}
        alt="Stryder logo mark"
        className={className}
        width={width}
        height={height}
        style={style}
      />
    </>
  );
};

export default Logo;
